import type { ActiveGameDataCash } from '@ps/web-poker-types';
import { Translation } from '@ps/web-shared-components';
import type React from 'react';
import { useCallback } from 'react';

import useOpenActiveGame from '../../hooks/useOpenActiveGame';

import styles from './GameItem.module.scss';
import GameItemButtons from './GameItemButtons';
import sharedStyles from './shared.module.scss';
import { GAME_TYPE_TRANSLATIONS } from './utils/utils';

interface Props {
  game: ActiveGameDataCash;
}

const GameItemCash: React.FC<Props> = ({ game }) => {
  const { focusActiveGame } = useOpenActiveGame();

  const handleTakeSeat = useCallback(() => {
    focusActiveGame({
      id: +game.id,
      type: game.type
    });
  }, [game, focusActiveGame]);

  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        <p className={styles.type}>
          <Translation {...GAME_TYPE_TRANSLATIONS[game.type]} />
        </p>
        <p className={styles.title}>
          {game.name}
          <span className={sharedStyles.separator}>&nbsp;|&nbsp;</span>
          {game.gameFormat}
        </p>
      </div>
      <GameItemButtons hasStartTime={false} game={game} onOpen={handleTakeSeat} />
    </div>
  );
};

export default GameItemCash;
